import React, { useState, useEffect } from "react";
import icon1 from "../../assets/Vector.svg";
import icon2 from "../../assets/Vector 2.svg";
import icon3 from "../../assets/Vector 3.svg";
import icon4 from "../../assets/passwordicon.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { STATE } from "../../utils/stateConstants";
import { toast } from "react-toastify";
import { containsSpecialChars } from "../../utils/regression";
import { signUp } from "../../services/authService";

function SignUpPage(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [comfirmPassword, setComfirmPassword] = useState("");
  const [allPassed, setAllPassed] = useState(false);
  const [status, setStatus] = useState(STATE.IDLE);
  const [canSubmit, setCanSubmit] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (values, methods) => {
    try {
      setStatus(STATE.LOADING);
      const userObj = {
        username: formik.values.username,
        email: formik.values.email,
        phoneNumber: formik.values.phoneNumber,
        password: formik.values.password,
      };
      const response = await signUp(userObj);
      setStatus(STATE.SUCCESS);
      toast.success(response.data.message);
      setTimeout(() => {
        navigate("/sign-in");
      }, 2000);
    } catch (err) {
      toast.error(
        err.response?.data?.message || "An Error has occured. Please try again."
      );
      setStatus(STATE.ERROR);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      email: "",
      phoneNum: "",
      password: "",
    },
    validationSchema: Yup.object({
      // email: Yup.string()
      //   .email("Invalid email address.")
      //   .required("Email is required."),
      // username: Yup.string()
      //   .min(3, "Minimum of 3.")
      //   .required("Username is required."),
      // phoneNum: Yup.string()
      //   .matches(/^\d{13}$/, "Phone number is not valid")
      //   .required("Phone number is required"),
    }),
    onSubmit: (values,metho) => {
      handleSignUp(values);
    },
  });

  useEffect(() => {
    setAllPassed(false);
    formik.values.password &&
      /[a-z]/.test(formik.values.password) &&
      /[A-Z]/.test(formik.values.password) &&
      /[0-9]/.test(formik.values.password) &&
      containsSpecialChars(formik.values.password) &&
      formik.values.password.length > 7 &&
      formik.values.password !== formik.values.password||
      setAllPassed(true);
  }, [formik?.values?.password]);

  document.title = "Tyrion | Sign Up";

  return (
    <div className="font-['DM Sans'] w-340 md:w-767 mx-auto h-auto bg-white px-14 md:px-28  rounded-lg">
      <h4 className="md:text-4xl text-2xl text-center pt-8 md:pt-16 font-semibold mt-6 md:mt-11 mb-1.5">
        Create an account
      </h4>
      <p className="md:text-xl mb-8 md:mb-16 text-center text-[#00000058]">
        Fill in the details to create a{" "}
        <span className="text-[#FBC108]">tyrion</span> account
      </p>
      <form onSubmit={formik.handleSubmit} onChange={formik.handleChange}>
        <div className="form-control mb-5 md:mb-10">
          <label className="font-medium md:text-lg">Username</label>
          <div className=" relative flex ">
            <img
              src={icon1}
              alt=""
              className="w-3 absolute bottom-2.5 md:bottom-6 ml-4"
            />
            <input
              for="username"
              type="text"
              placeholder="Username"
              className="w-72 md:w-558 h-8 md:h-16 border border-gray rounded-lg pl-10 font-normal text-[rgba(0, 0, 0, 0.24)] text-sm md:text-lg "
              name="username"
              required
              onChange={formik.handleChange}
              value={formik.values.username}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.username && formik.errors.username ? (
            <div className="flex text-center text-rose-300">
              {" "}
              {formik.errors.username}{" "}
            </div>
          ) : null}
        </div>

        <div className="form-control mb-5 md:mb-10">
          <label className="font-medium md:text-lg">Email</label>
          <div className="relative flex">
            <img
              src={icon2}
              alt=""
              className="w-3 absolute bottom-2.5 md:bottom-6 ml-4"
            />
            <input
              for="email"
              type="email"
              placeholder="Input your email"
              className="w-72 md:w-558 h-8 md:h-16 border border-gray rounded-lg pl-10 font-normal text-[rgba(0, 0, 0, 0.24)] text-sm md:text-lg "
              name="email"
              required
              onChange={formik.handleChange}
              value={formik.values.email}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.email && formik.errors.email ? (
            <div className="flex text-center text-rose-300">
              {" "}
              {formik.errors.email}{" "}
            </div>
          ) : null}
        </div>

        <div className="form-control mb-5 md:mb-10">
          <label className="font-medium md:text-lg">Phone number</label>
          <div className="relative flex ">
            <img
              src={icon3}
              alt=""
              className="w-3 absolute bottom-2.5 md:bottom-6 ml-4"
            />
            <input
              for="phoneNum"
              type="phoneNum"
              placeholder="Phone number"
              className="w-72 md:w-558 h-8 md:h-16 border border-gray rounded-lg pl-10 font-normal text-[rgba(0, 0, 0, 0.24)] text-sm md:text-lg"
              name="phoneNum"
              required
              onChange={formik.handleChange}
              value={formik.values.phoneNum}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.tel && formik.errors.tel ? (
            <div className="flex text-center text-rose-300">
              {" "}
              {formik.errors.phoneNum}{" "}
            </div>
          ) : null}
        </div>
        <div className="form-control mb-5 md:mb-10">
          <label className="font-medium md:text-lg">Password</label>
          <div className="relative flex ">
            <img
              src={icon4}
              alt=""
              className="w-3 absolute bottom-2.5 md:bottom-6 ml-4"
            />
            <input
              for="password"
              type="password"
              placeholder="Input your password"
              className="w-72 md:w-558  h-8 md:h-16 border border-gray rounded-lg pl-10 font-normal text-[rgba(0, 0, 0, 0.24)] text-sm md:text-lg"
              name="password"
              required
              onChange={formik.handleChange}
              value={formik.values.password1}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.password && formik.errors.password ? (
            <div className="flex text-center text-rose-300">
              {" "}
              {formik.errors.password}{" "}
            </div>
          ) : null}
        </div>
        <div  className={`form-control mb-5 md:mb-10${
              !formik.values.confirmPassword &&
              formik.touched.confirmPassword
                ? "border border-red-600"
                : formik.values.confirmPassword &&
                  formik.values.password === formik.values.confirmPassword
                ? "border border-cyan-600"
                : "border border-red-600"
            }`}
          > 
          <label htmlFor="confirmPassword" className="font-medium md:text-lg">Repeat password</label>
          <div className="relative flex ">
            <img
              src={icon4}
              alt=""
              className="w-3 absolute bottom-2.5 md:bottom-6 ml-4"
            />
            <input
              type="password"
              placeholder="Input your password"
              className="w-72 md:w-558 h-8 md:h-16 border border-gray rounded-lg pl-10 font-normal text-[rgba(0, 0, 0, 0.24)] text-sm md:text-lg "
              name="confirmPassword"
              id="confirmPassword"
              required
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.password && formik.errors.password ? (
            <div className="flex text-center text-rose-300">
              {" "}
              {formik.errors.password}{" "}
            </div>
          ) : null}
        </div>

        <button
          className="w-228 md:w-550 h-8 md:h-16 bg-[#FBC108] text-white mb-2.5 md:mb-5 rounded-lg font-medium text-sm md:text-lg hover:bg-[#FFCC00] active:bg-[#fbc10886]"
          type="submit"
        >
          Create an account
        </button>
      </form>
      <h4 className="text-center text-sm  md:text-lg pb-7 md:pb-14">
        Already have an account?{" "}
        <span
          className="text-[#fbc108] cursor-pointer active:bg-[#fbc10886]"
          onClick={() => navigate("/sign-in")}
        >
          Sign in
        </span>
      </h4>
    </div>
  );
}

export default SignUpPage;
